import React from 'react';
import cn from 'classnames';
import ReactPlayer from 'react-player/lazy';
const DaVideoPlayer = ({ src, width, height, className })=>{
    if (!ReactPlayer.canPlay(src)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "video-inner",
        className: cn('main-video', className),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(ReactPlayer, {
        controls: true,
        config: {
            youtube: {
                playerVars: {
                    fs: 0
                }
            }
        },
        url: src,
        width: width,
        height: height
    }));
};
export default DaVideoPlayer;

//# sourceMappingURL=DaVideoPlayer.js.map